<template>
  <div class="">
    <stats></stats>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Stats from "@/components/accounting/stats/index.vue";

export default {
  props: {},
  components: { Stats },
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  created() {
    this.notifyQueue({
      text: "Contabilità",
      path: "",
      level: 1,
    });
    this.notifyQueue({
      text: "Stats",
      path: "module.CONT.STAT",
      level: 2,
    });
  },
};
</script>
